module.exports = __webpack_public_path__ + "static/media/lineTool.ed6be627.gif";